"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteTaggedContainerSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const meta_data_1 = require("../base/meta-data");
exports.WaysteTaggedContainerSchema = {
    name: 'wayste-tagged-container',
    alias: 'Wayste Tagged Container',
    shortName: 'Container',
    applications: ['wayste'],
    returnType: {
        wayste: transport_types_1.Dumpster.TaggedContainerTransport,
    },
    searchableAttributes: [
        {
            field: 'name',
            alias: 'Name',
            shortName: 'dumpster',
            searchableByDefault: true,
        },
        {
            field: 'decal',
            alias: 'Decal',
            shortName: 'dumpster_decal',
            searchableByDefault: true,
        },
    ],
    filterableAttributes: [
        {
            field: 'containerType.style',
            type: 'STRING',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            alias: 'Container Style',
            shortName: 'Style',
            options: transport_types_1.Dumpster.ContainerTypes.map((style) => ({
                value: style,
                label: transport_types_1.Dumpster.ContainerTypeLabels[style],
            })),
        },
        {
            field: 'status',
            type: 'STRING',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            alias: 'Status',
            shortName: 'Status',
            options: transport_types_1.Dumpster.ContainerStatuses.map((status) => ({
                value: status,
                label: transport_types_1.Dumpster.ContainerStatusLabels[status],
            })),
        },
        ...meta_data_1.MetaDataFilters,
    ],
    dropFields: [],
    extraMappings: [],
};
//# sourceMappingURL=wayste-tagged-container.js.map